import { Divider, Switch } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { Col3Col9, Section } from '../../common';

export interface ISurveyResponseStreamSetupProps {
	isResponseStreamed: boolean;
	ResponseStreamFlagChanged: () => void;
}

export class SurveyResponseStreamSetup extends React.PureComponent<ISurveyResponseStreamSetupProps> {
	public render() {
		return (
			<Section id={ContentConstants.ID_RESPONSE_STREAMING} sectionHeader={ContentConstants.SECTIONHEADERS_RESPONSE_STREAM}>
				<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_INSTRUCTIONS}>
					<div>{ContentConstants.INSTRUCTIONALTEXT_RESPONSE_STREAM}</div>
				</Col3Col9>
				<Divider type='dashed' />
				<Col3Col9>
					<Switch text='Enable Live Responses' getValue={this.props.ResponseStreamFlagChanged} checked={this.props.isResponseStreamed} />
				</Col3Col9>
			</Section>
		);
	}
}
